var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.1,6c.5,0,1-.4,1-1s-.4-1-1-1h-1.2c1.2-1.3,2.9-2.1,4.7-2,2.4,0,4.5,1.4,5.4,3.6.1.2.3.4.5.5.1,0,.2,0,.3,0s.3,0,.4,0c.5-.2.7-.8.5-1.3C14.5,2,11.7.2,8.6.2c-2.6,0-5,1.1-6.5,3.1V1.1c0-.5-.4-1-1-1S.2.6.2,1.1v3.9c0,.5.4,1,1,1h3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9,10h-3.9c-.5,0-1,.4-1,1s.4,1,1,1h1.3c-1,1.3-2.6,2-4.2,2-2.4,0-4.5-1.4-5.4-3.6-.2-.5-.8-.7-1.3-.5-.5.2-.7.8-.5,1.3,1.2,2.9,4.1,4.7,7.2,4.7,0,0,.1,0,.2,0,2.3,0,4.4-1.1,5.7-2.9v2c0,.5.4,1,1,1s1-.4,1-1v-3.9c0-.5-.4-1-1-1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.f97caea09ef87f8bb53a9603db95c1c3.svg";
export { ForwardRef as ReactComponent };